import { withResult } from 'feathers-fletching';
import { statusType, truckType } from 'straightline-utils/constants';

const withResults = withResult({
  status: (shipment) => {
    if (shipment.status_type) {
      return statusType(shipment.status_type);
    }
  },
  truck: (shipment) => {
    if (shipment.truck_type) {
      return truckType(shipment.truck_type);
    }
  },
  pickup_address: async (match, context) => {
    if (!match.pickup_address) {
      return match.pickup_address;
    }

    if (!context.params.$include?.includes('pickup_address')) {
      return match.pickup_address;
    }

    try {
      const { latitude, longitude, position } = await context.app
        .service('google/geocode')
        .find({
          query: {
            address: `${match.pickup_address.city || ''}, ${
              match.pickup_address.state || ''
            } ${match.pickup_address.country || ''}`
          }
        });

      return {
        ...match.pickup_address,
        latitude,
        longitude,
        position
      };
    } catch (error) {
      return match.delivery_address;
    }
  },
  delivery_address: async (match, context) => {
    if (!match.delivery_address) {
      return match.delivery_address;
    }

    if (!context.params.$include?.includes('delivery_address')) {
      return match.delivery_address;
    }

    try {
      const { latitude, longitude, position } = await context.app
        .service('google/geocode')
        .find({
          query: {
            address: `${match.delivery_address.city || ''}, ${
              match.delivery_address.state || ''
            } ${match.delivery_address.country || ''}`
          }
        });

      return {
        ...match.delivery_address,
        latitude,
        longitude,
        position
      };
    } catch (error) {
      return match.delivery_address;
    }
  },
  route: async ({ route }, context) => {
    if (!route) {
      return route;
    }

    return {
      ...route,
      directions: await context.app
        .service('api/shipment-routes')
        .parseDirections(route)
    };
  },
  tracking: ({ tracking }) => {
    if (!tracking) {
      return tracking;
    }
    return tracking.map((track) => {
      return {
        ...track,
        position: {
          lat: Number(track.latitude),
          lng: Number(track.longitude)
        }
      };
    });
  }
});

export default {
  before: {
    all: [],
    get: [],
    patch: []
  },
  after: {
    all: [withResults],
    get: [],
    patch: []
  },
  error: {
    all: [],
    get: [],
    patch: []
  }
};
